import { TextMediumSM } from "../../../../../Components/Text/MediumText"
import PurposeOfRequest from "./PurposeOfRequest";
import RequestFor from "./RequestFor";
import Status from "./Status";


const Request = () =>{
    return(
        <>
        <TextMediumSM content="Request" />
        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <RequestFor/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <PurposeOfRequest/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <Status/>
         </div>
         </div>
         </>
    )
}

export default Request;